
    import '/vercel/path0/docs/demo/with-portal.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-demo-with-portal-demo-with-portal"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/demo/with-portal.md?type=demo')
};